module.exports = __webpack_public_path__ + "img/gzhlwfy.741a5b4e.png";